var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-section-group-layout",
    { staticClass: "group-wrapper p-4 my-4 card" },
    [
      _c("section-title", { attrs: { "title-type": "subtitle" } }, [
        _c("span", { staticClass: "bold" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("application-standalone.questions.additionalInformation")
              ) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea-field", {
        attrs: {
          value: _vm.additionalInformation,
          placeholder: _vm.$t("documents.writeAComment") + "...",
          label: _vm.$t("documents.writeAComment") + "...",
          "hidden-label": "",
        },
        on: {
          "update:value": function ($event) {
            _vm.additionalInformation = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }